interface AnalyticsPluginRestProxyTrackArgs {
  event: object;
  topic: string;
}

// Payload sent to sentEvent of RestProxy
// this is a better name as not all usages of this service are through the analytics plugin
type RestProxyPayload = AnalyticsPluginRestProxyTrackArgs;

interface BaseEvent {
  anonymous_id?: string;
  context_library_name: string;
  git_commit_id: string;
  event_text: string;
  user_uid?: string;
  uuid: string;
}

const EXPERIMENT_TRIGGERS_INTAKE_TOPIC = "experiment_triggers_raw";

const EXPERIMENT_ASSIGNMENTS_INTAKE_TOPIC = "experiment_assignments_raw";

const LEARNER_TRACKING_INTAKE_TOPIC = "tracking_events_raw";

// for generic events and data
const ANALYTICS_EVENTS_TOPIC = "analytics_events";

export {
  BaseEvent,
  AnalyticsPluginRestProxyTrackArgs,
  RestProxyPayload,
  EXPERIMENT_TRIGGERS_INTAKE_TOPIC,
  EXPERIMENT_ASSIGNMENTS_INTAKE_TOPIC,
  ANALYTICS_EVENTS_TOPIC,
  LEARNER_TRACKING_INTAKE_TOPIC,
};
